<script>
  let username = "";
  let email = "";
  let password = "";
  let district = "";
  let level = "";
  let selectedDistricts = [];

  import { districts_data } from "./data/district_data.js";
  import { serverURL } from "./store.js";

  const handleSubmit = async (event) => {
    if (window.location.hostname == "localhost") {
      $serverURL = "http://localhost:8080/";
    }
    event.preventDefault();
    try {
      const response = await fetch(`${$serverURL}api/users/signup`, {
        // Replace with your actual API endpoint
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          email,
          password,
          selectedDistricts,
          level,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        alert("User Created and Email Sent");
        console.log("User created successfully:", result);
        // Redirect or show a success message
      } else {
        console.error("Error creating user:", result);
        // Handle errors
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  // Example districts, replace these with real district names
  const districts = districts_data.sort((a, b) => a.name.localeCompare(b.name));
  function handleDistrictChange(event, districtName) {
    if (event.target.checked) {
      selectedDistricts = [...selectedDistricts, districtName];
    } else {
      selectedDistricts = selectedDistricts.filter(
        (district) => district !== districtName
      );
    }
  }
</script>

<form on:submit={handleSubmit}>
  <label for="username">Name:</label>
  <input type="text" id="username" bind:value={username} required />

  <label for="email">Email:</label>
  <input type="email" id="email" bind:value={email} required />

  <label for="password">Password:</label>
  <input type="password" id="password" bind:value={password} required />

  <label for="district">District: {selectedDistricts.join(", ")}</label>

  <div style="height:200px;overflow:auto;width:300px">
    <label>
      <input
        type="checkbox"
        value={"All"}
        on:change={(e) => handleDistrictChange(e, "All")}
      />
      All
    </label>
    {#each districts as district}
      <label>
        <input
          type="checkbox"
          value={district.name}
          on:change={(e) => handleDistrictChange(e, district.name)}
        />
        {district.name}
      </label>
    {/each}
  </div>

  <label for="level">Level:</label>
  <select id="level" bind:value={level} required>
    <option value="" disabled selected>Select your Level</option>
    <option value="level1">Level 1</option>
    <option value="level2">Level 2</option>
  </select>

  <button type="submit">Sign Up</button>
</form>

<style>
  * {
    margin-left: 20px;
  }
</style>
